class TimelinePin {
	static fromArray(layer, data) {
		let inst = new TimelinePin(layer);
		inst._id = data.shift();
		inst._name = data.shift();
		inst._time = data.shift() * 1000;
		inst._color = data.shift();

		return inst;
	}
	constructor(layer) {
		this.layer = layer;
		this._id;
		this._name;
		this._time;
		this._color;

		this._elem = null;
	}
	get id() { return this._id; }
	get name() { return this._name; }
	get time() { return this._time; }
	get color() {return this._color}
	get elem() { 
		if (this._elem === null) {
			this._elem = UI.loadTip(UI.div('timeline-pin i-xl i-pin tooltip norm', null, null, {
				'data-tip' : 'above',
				'aria-label': this._name
			}));

			this._elem.style.color = '#' + this.color;
		}
		return this._elem; 
	}
	set visible (value) {
		this.elem.style.display = value ? 'block' : 'none';
	} 
	checkVisible(viewStart, viewEnd) {
		this.elem.style.display = (this.time < viewStart || viewEnd < this.time) ? 'none' : 'block';
	}
	update () {
		this._elem.style.left = this.layer.timeToOffset(this.time) + 'px';
	}
}